
export default (API_URL: string, axiosInstance: any): any => {
  return {
    login: async ({ username, password }: { username: string, password: string }) => {
      try {
        axiosInstance.defaults.headers.common.username = username
        axiosInstance.defaults.headers.common.password = password
        const result = await axiosInstance.post(`${API_URL}/login`)
        if (result.data.result) {
          localStorage.setItem('username', username)
          localStorage.setItem('password', password)
          axiosInstance.defaults.headers.common.username = username
          axiosInstance.defaults.headers.common.password = password
          return {
            success: true,
            redirectTo: (() => {
              const searchParams = new URLSearchParams(window.location.search)
              let to = searchParams.get('to')
              if (!to && window.location.hash.includes('?')) {
                const hashParams = new URLSearchParams(window.location.hash.split('?')[1])
                to = hashParams.get('to')
              }
              const redirect = to ?? '/dashboard'
              if (to) {
                setTimeout(() => {
                  window.location.replace(redirect)
                }, 200)
                return false
              }
              return redirect
            })(),
            successNotification: {
              message: 'Login Successful',
              description: 'You have successfully logged in.'
            }
          }
        } else {
          return {
            success: false,
            error: {
              message: 'Login Error',
              name: 'Invalid email or password'
            }
          }
        }
      } catch (error: any) {
        return {
          success: false,
          error: {
            message: 'Login Error',
            name: error.response ? error.response.data.error : error
          }
        }
      }
    },
    logout: async () => {
      delete axiosInstance.defaults.headers.common.username
      delete axiosInstance.defaults.headers.common.password
      localStorage.removeItem('username')
      localStorage.removeItem('password')
      return {
        success: true,
        redirectTo: '/login',
        successNotification: {
          message: 'Logout Successful',
          description: 'You have successfully logged out.'
        }
      }
    },
    onError: async (error: any) => {
      if (process.env.NODE_ENV !== 'development' && (error.response?.status === 401 || error.response?.status === 403)) {
        return {
          redirectTo: '/login',
          logout: true,
          error
        }
      }
      return { error }
    },
    check: async () => {
      const username = localStorage.getItem('username')
      const password = localStorage.getItem('password')
      if (username && password) {
        axiosInstance.defaults.headers.common.username = username
        axiosInstance.defaults.headers.common.password = password
        return {
          authenticated: true
        }
      } else {
        const currentPath = window.location.pathname + window.location.search
        const toParam = currentPath !== '/login' ? `?to=${encodeURIComponent(currentPath)}` : ''
        const redirectTo = `/login${toParam}`

        // Force redirect if we are at root and not authenticated, to ensure 'to' param is set
        if (window.location.pathname === '/' && !window.location.search.includes('to=')) {
          window.location.replace(redirectTo)
          return {
            authenticated: false,
            redirectTo,
            logout: true,
            error: {
              message: 'Check failed',
              name: 'User not found'
            }
          }
        }

        return {
          authenticated: false,
          redirectTo,
          logout: true,
          error: {
            message: 'Check failed',
            name: 'User not found'
          }
        }
      }
    },
    getPermissions: async () => ['admin'],
    getIdentity: async () => {
      const username = localStorage.getItem('username')
      return {
        name: username,
        avatar: 'https://i.pravatar.cc/150'
      }
    }
  }
}
